import React from 'react';
import { Upload } from 'Utils/SvgIcons';

const CsvHandler = (props) => {
  const { fileHandler, selectedFile } = props;

  return (
    <label className='uploadInput'>
      <Upload />
      {selectedFile?.name
        ? selectedFile?.name
        : 'Upload File (.csv, .xlsx, .ods)'}
      <input
        type='file'
        name='csv'
        accept='.csv,.xlsx,.ods,text/csv,application/vnd.ms-excel'
        onChange={fileHandler}
      />
    </label>
  );
};

export default CsvHandler;
